import { dota2_metablob_v1 } from './v1';

export function createDota2Metablob(metadata: Record<string, string>): dota2_metablob_v1 | null {
  try {
    const postGameEvent = JSON.parse(metadata.postGameEvent || '{}');
    return {
      metablobVersion: 'dota2_metablob_v1',
      matchId: metadata.matchId,
      winner: (metadata.winner || 'unknown') as 'radiant' | 'dire' | 'unknown',
      playerHero: metadata.playerHero,
      playerTeam: (metadata.playerTeam || 'unknown') as 'radiant' | 'dire' | 'unknown',
      playerKills: postGameEvent.player?.kills || 0,
      playerDeaths: postGameEvent.player?.deaths || 0,
      playerAssists: postGameEvent.player?.assists || 0,
      playerLastHits: postGameEvent.player?.last_hits || 0,
      playerDenies: postGameEvent.player?.denies || 0,
      playerGPM: postGameEvent.player?.gpm || 0,
      playerXPM: postGameEvent.player?.xpm || 0,
      playerLevel: postGameEvent.hero?.level || 0,
      radiantScore: postGameEvent.map?.radiant_score || 0,
      direScore: postGameEvent.map?.dire_score || 0,
      gameDurationSeconds: postGameEvent.map?.game_time || 0,
    };
  } catch (error) {
    console.error('Failed to create Dota 2 metablob:', error);
    return null;
  }
}

export function parseDota2Metablob(metablob: string | undefined): dota2_metablob_v1 | undefined {
  if (!metablob) return undefined;
  try {
    const parsed = JSON.parse(metablob);
    return parsed?.metablobVersion === 'dota2_metablob_v1' ? (parsed as dota2_metablob_v1) : undefined;
  } catch {
    return undefined;
  }
}
